<template>
  <v-row v-if="$vuetify.display.smAndUp" no-gutters class="sz-white">
    <v-col cols="12" class="border-bottom">
      <p class="text-center pa-3 mb-0 sz-secondary-grey--text font-weight-medium f-18">
        {{ $t('label.filters') }}
      </p>
    </v-col>
    <v-col cols="12">
      <FilterExpansionPanels />
    </v-col>
  </v-row>
  <div v-else>
    <a class="primary-link font-weight-medium f-24" @click="openMobileDialog">
      <v-icon color="szViolet" :size="22">$filter</v-icon>
      {{ $t('label.filters') }}
    </a>
    <v-dialog v-model="mobileDialog" fullscreen width="100%" class="pa-0" scrollable>
      <v-card>
        <v-card-title class="pa-3 pl-6 pt-2 pb-1 border-bottom">
          <v-row no-gutters justify="end">
            <v-col>
              <p class="text-left mb-0 sz-secondary-grey--text font-weight-medium f-18">
                {{ $t('label.filters') }}
              </p>
            </v-col>
            <v-col v-ripple cols="auto" class="pointer px-2" @click="closeMobileDialog">
              <v-icon :size="18" class="ico-45-deg" color="szGrey"> $tagClose </v-icon>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="pa-0 ma-0">
          <FilterExpansionPanels @close="closeMobileDialog" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import FilterExpansionPanels from '@/components/FamiliesList/Filters/FilterExpansionPanels.vue'
export default {
  name: 'FiltersComponent',
  components: { FilterExpansionPanels },
  data() {
    return {
      mobileDialog: false
    }
  },
  created() {
    this.$store.dispatch('families/getResourceFilter', this.$route.params.bubbleId)
  },
  methods: {
    closeMobileDialog() {
      this.mobileDialog = false
    },
    openMobileDialog() {
      this.mobileDialog = true
    }
  }
}
</script>
